// extracted by mini-css-extract-plugin
export var active = "_d5-7";
export var container = "_d5-0";
export var evenWidth = "_d5-4";
export var large = "_d5-5";
export var outlet = "_d5-8";
export var slide = "_d5-2";
export var small = "_d5-6";
export var tab = "_d5-3";
export var tabs = "_d5-1";